
// SPINNER
export const CORE_SPINNER = "CORE_SPINNER";

export const USER_ACTIVE = "USER_ACTIVE";


export const USER_PROFILE = "USER_PROFILE";

export const USER_ROLE= "USER_ROLE";